// extracted by mini-css-extract-plugin
export var merchant = "s_cS";
export var header = "s_cN";
export var info = "s_h";
export var name = "s_bL";
export var specialties = "s_cP";
export var descriptions = "s_cQ";
export var productList = "s_cR";